var map = {
	"./bg.jpg": 338,
	"./contact_image.png": 317,
	"./new-year-gift.png": 212,
	"./top.png": 566,
	"images/bg.jpg": 338,
	"images/contact_image.png": 317,
	"images/new-year-gift.png": 212,
	"images/top.png": 566
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 866;